import { useQuery } from '@tanstack/react-query';
import { getMultiplexPanels, getMultiplexPanelsQueryKey } from 'api/multiplexPanels';
import { MultiplexPanelsResponse } from 'interfaces/multiplexPanels';
import { Study } from 'interfaces/study';
import { isWorkflowStepApproved } from './studyWorkflowModel';

export const isMultiplexPanelCohortApproved = (
  study: Pick<Study, 'settings'> | undefined,
  panels?: MultiplexPanelsResponse
) => {
  if (!study?.settings?.multiplexPanels?.length)
    return isWorkflowStepApproved(study?.settings?.workflowStepApprovals, 'marker-assignments');
  return Boolean(panels && panels.totalSlidesCount > 0 && panels.approvedSlidesCount === panels.totalSlidesCount);
};

export const useMultiplexPanelApproval = (study: Study | undefined, labId?: string, enabled = true) => {
  const hasSavedPanels = Boolean(study?.settings?.multiplexPanels?.length);
  const casesParams = { labId, studyId: study?.id, filters: { studyId: study?.id }, slidesMode: true };
  const query = useQuery({
    queryKey: getMultiplexPanelsQueryKey(casesParams),
    queryFn: ({ signal }) => getMultiplexPanels(casesParams, signal),
    enabled: enabled && Boolean(study?.id),
  });
  return {
    ...query,
    hasSavedPanels,
    isApproved: isMultiplexPanelCohortApproved(study, query.data),
    isLoading: enabled && query.isLoading,
  };
};
